import { fontWeights } from 'syf-component-library/defaultTheme';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 10px 10px 20px 10px;
`;
export const UserCardContainer = styled(Container) `
    flex-direction: row-reverse; 
`;
export const AgentCardContainer = styled(Container) `
    justify-content: flex-start;
`;
export const AgentCardMessageContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
export const AgentCardBubbleContent = styled.div `
  margin: 1em;
  align-self: flex-start; 
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  &>button, &>a {
    margin-top: 10px;
    font-family: ${(props) => props.theme.fontFamily} !important;
    font-size: ${props => props.theme.fontSizes.default};
    height: auto !important;
    line-height: normal !important;
  }
`;
const TextContainer = styled.div `
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  
 /* Instead use this non-standard one: */
  word-break: break-word;

  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

  font-size: ${props => props.theme.fontSizes.default};
  line-height: 1.38;
  display: inline-block;
`;
export const AgentText = styled(TextContainer) `
    &>p {
      margin: 0;
    }
`;
export const SectionHeader = styled.h6 `
    font-weight: ${fontWeights.semiBold};
`;
export const UserText = styled(TextContainer) `
  align-self: flex-end;
  margin: 1em;
`;
